import type { DataEditorProps } from "@glideapps/glide-data-grid";
import { useMemo } from "react";
import {
  spreadsheetRegionHighlightRange,
  type SpreadsheetRegionDraft,
} from "./spreadsheet-region";
import { volcaColorAlpha } from "./spreadsheet-theme";

export const useGridHighlightRegions = (
  regionPreview: SpreadsheetRegionDraft | null,
  searchHighlightRegions: DataEditorProps["highlightRegions"],
) =>
  useMemo(() => {
    const previewRange = regionPreview
      ? spreadsheetRegionHighlightRange(regionPreview)
      : null;
    const previewHighlights = previewRange
      ? [
          {
            color: volcaColorAlpha("--cyan-10", 0.33),
            range: { ...previewRange, height: 1 },
            style: "solid-outline" as const,
          },
          {
            color: volcaColorAlpha("--cyan-9", 0.2),
            range: {
              ...previewRange,
              y: previewRange.y + 1,
              height: Math.max(previewRange.height - 1, 1),
            },
            style: "solid" as const,
          },
        ]
      : [];

    return [...(searchHighlightRegions ?? []), ...previewHighlights];
  }, [regionPreview, searchHighlightRegions]);
